export enum ContentSelectionStrategy {
  Specific = 'Specific Item',
  Matching = 'Custom Matching',
}

export enum ContentSelectionStrategyValue {
  Specific = 'Specific',
  Matching = 'Matching',
  ContentSetRandom = 'RandomContent',
}

export enum ContentFeedUpdateStatus {
  Started = 'Started',
  Completed = 'Completed',
  Failed = 'Failed',
  FinishedWithIssues = 'Finished with issues',
}
